import React from 'react';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { ManageAddressesCreate } from '@components/templates/myAccount/manageAddressesCreate/ManageAddressesCreate';

export function ManageAddressesCreatePage() {
    const { t } = useTranslation();

    const translations = {
        title: t('manage-addresses-create-component.metatags.title'),
        description: t('manage-addresses-create-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myAddressesCreate,
        index: false,
    });

    return <ManageAddressesCreate />;
}
